import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Translate from "src/components/Translate";
import { sClassSerialNo } from "src/styles/sClassSerialNo.module.scss";
import { sVideoLabel } from "src/styles/sVideoLabel.module.scss";
import { VariantSize } from "src/types/VariantSize";

type Props = {
  size?: VariantSize | null | undefined;
  className?: (string | string) | null | undefined;
  style?: CSSProperties | null | undefined;
  value: number;
};

function NftNumber({ size, className, style, value }: Props) {
  return value ? (
    <div
      style={style}
      className={composeClassNames([
        sVideoLabel,
        "light",
        sClassSerialNo,
        size,
        className,
        "class-serial-no",
      ])}
    >
      <div>#{String(value)}</div>
    </div>
  ) : null;
}

export default NftNumber;
